<template>
  <div class="view-pdf">
  	<div style="position: fixed; top: 18%; left: 50%; z-index: 999;">
      <looping-rhombuses-spinner
        v-if="loading"
        :animation-duration="speed"
        :rhombus-size="config.size"
        :color="spinnersColor"
      />
    </div>
    <div class="flex xs12">
	    <va-card>
	    	<template slot="actions">           
              <va-button icon="fa fa-calendar" @click="SetFilter()" v-if="!showCalandar"  > Set Filter</va-button> 
              <va-button type="submit" id="my-form"  v-if="showCalandar"  @click="fetchPdf($event)">
                  {{ $t('forms.controls.submit') }}
              </va-button>
			
              <va-button type="submit" id="my-form"  v-if="showYear"  @click="fetchPdf($event)">
                  {{ $t('forms.controls.submit') }}
              </va-button>
	        </template> 
	    	<form id="my-form"> 
	    		<div  class="row flex xs12" v-if="showCalandar">
	    			<div class="flex xs12 sm6">
			            <va-date-picker 
			                :label="$t('forms.dateTimePicker.from')"
			                :config="{
			                	locale: {firstDayOfWeek: 1},
			                	inline: false,
			                	position:'below',
			                	altInput:true,
			                	minDate:SixMonthsAgo,
			                	maxDate:today
			                }"
			                v-model="datepicker.from"
			            />
			        </div>
			        <div class="flex xs12 sm6">
			            <va-date-picker 
			                :label="$t('forms.dateTimePicker.to')"
			                :config="{
			                	locale: {firstDayOfWeek: 1},
			                	inline: false,
			                	position:'below',
			                	altInput:true,
			                	minDate:SixMonthsAgo,
			                	maxDate:today
			                }"
			                v-model="datepicker.to"
			            />
			        </div>
			        <div class="flex xs12 sm6">
						<va-select
			              v-if = "isfosa"
			              class="mb-4"
			              label="Account"
			              v-model="datepicker.acc_code"
			              textBy="accname"              
			              :options="accounts"
			              key-by="paybill_code"              
			            />
			        </div>	
	            </div>
				<div class="flex xs12 sm6" v-if="showYear">
						<va-select
						v-if = "isdevidend"
						class="mb-4"
						label="Select Year"
						textBy="fiscal_name"
						v-model="fiscal_name" 
						:loading = "loadSelect"
						:options="years"      
						key-by="fiscal_name"              
						/>
						
						
					</div>	
					<div class="flex xs12 sm6" v-if="getcheckoffs">
						<va-select
	
						class="mb-4"
						label="Select Checkoff"
						textBy="no"
						v-model="no" 
						:loading = "loadSelect"
						:options="checkoffcodes"      
						key-by="no"              
						/>
						
						
					</div>           
            </form>

            <div  class="row flex xs12">
			    <object :data="documentPath" type="application/pdf" style="width: 100%; height: 720px; z-index: 998;" v-if="doc">
			    	<p>It appears you don't have a PDF plugin for this browser. 
						<a :href = "documentPath" download="document.pdf">Click here to download the file.</a>
				    </p>	
			    </object>
			</div>
		</va-card>
	</div>



  


  </div>
</template>

<script>
import axios from 'axios'

import * as spinners from 'epic-spinners'
export default {
	components: {
		...spinners      
	},
	name: 'view-pdf',
	data () {
	    return {
	    	showCalandar:false,
			showYear:false ,
	    	loading: false,
			yearpicker: '',
			fiscal_name: '',
	    	isfosa:false,
			no:'',
			isdevidend:false,
			getcheckoffs:false,
			 selectedYear: new Date().getFullYear(),
	    	doc : false,
	    	acc_cd: '',
	    	acc_details:{},
	    	accounts:JSON.parse(localStorage.getItem('UserFosas')),
	    	userData: JSON.parse(localStorage.getItem('LoggedUser')),
	    	token: JSON.parse(localStorage.getItem('Token')),
	    	loan_no : '',	       
	        documentPath:"",
	        config: {
		        size: 38,
		        duration: 1500,
		    },
		    spinnersColor: this.$themes.secondary,
		    currentDuration: 1500,
		    SixMonthsAgo:'',
		    today:'',		    
		    sliderDuration: {
		        min: 1000,
		        max: 2000,
		    },
		    datepicker: {	        
		        from: '',
		        to: '',
		        acc_code: "",	       
		    },
			years: {	        
		        fiscal_name:''        
		    },
			checkoffcodes: {	        
		        no:''        
		    },
		    reportCode:'',		   
	    };
	},
	computed: {
	    speed () {
	      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
	    },	    
	}, 
	methods : {
		
		GetProduct(financial) {      
		return this.years.filter(item => item.fiscal_name.toLowerCase() === this.financial.toLowerCase());      
		}, 
		getcheckoffsfilter(financial) {      
		return this.checkoffcodes.filter(item => item.no.toLowerCase() === this.financial.toLowerCase());      
		},
	    async getYears () {
		  this.loading = true
		  const self = this

		  let config = {
			headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
		}

		//  if (this.isdevidend) {
		//   	this.acc_details = await this.getSelected(this.yearpicker.Year.year);
		//   	this.acc_year = this.acc_details.year;
		//   }
		  const postdata = {
		  	user : this.userData.user_id,
			// Year: this.acc_year,
		  	
		  	
		  };

		axios.post(`${this.$apiUrl}getfinancialyears`, postdata, config )
	      .then(function (res) {
		
			self.showYear = true
			self.loading = false
			res = res.data	        
			self.years = res
	        console.log(self.years)
	        	                      
	      })
	      .catch(function (error) {
	          console.log(error)
	      })
	    },



		async fetchPdf () {
		  this.loading = true
		  const self = this

		  let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

		  if (this.isfosa) {
		  	this.acc_details = await this.getSelected(this.datepicker.acc_code.paybill_code);
		  	this.acc_cd = this.acc_details.accname;
		  }
		  
		  const postData = {
		  	user : this.userData.user_id,
		  	range :  `${this.datepicker.from} to ${this.datepicker.to}`,
		  	code : this.reportCode,
		  	loan : this.loan_no,
		  	acc_code: this.acc_cd,
			fiscal_name: this.fiscal_name.fiscal_code,
			no: this.no.no
		  };   
	      axios.post(`${this.$apiUrl}ReadPdf`, postData, config )
	      .then(function (res) {	        
	        const resp =  res.data.pdf
	        self.documentPath = `data:application/pdf;base64,${resp}`	       
	        self.doc = true
	        self.loading = false
	        self.showCalandar = false	


	      })
	      .catch(function (error) {
	          console.log(error)
	      })
	    },
		GetgeneralCheckoff () {
      this.loadSelect = true
      this.loading = true
      const self = this
      const form = {
  user:this.userData.user_id,
  advices:'advices'
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }
      axios.post(`${self.$apiUrl}GetCheckoffs`, this.userData.user_id, config)
      .then(function (res) {

			self.loading = false
			self.loadSelect=false
			res = res.data	        
			self.checkoffcodes = res.checkoffs
			console.log(self.checkoffcodes);
      })
      .catch(function (error) {
          console.log(error)
      })
    },

	    SetFilter(){
	    	this.showCalandar = true;
			// this.showYear = false;

	    	if(this.reportCode == "FOSASTMNT"){
	    		this.isfosa = true
		    }		
				
	    },
		
		SetYear(){

			this.showYear = true;
			// this.showCalandar = false;

			if(this.reportCode == "DVDNTSTMNT"){
	    		this.isdevidend = true
		    }
	    }



	},
	created () {
		this.today  = this.$options.filters.dateToYMD(new Date());
		this.datepicker.to = this.today 
		this.SixMonthsAgo = this.$options.filters.createDate(0,-6,0)
		this.SixMonthsAgo = this.$options.filters.dateToYMD(this.SixMonthsAgo)
		this.datepicker.from = this.SixMonthsAgo
		let thePath = {};
		thePath = this.$route.fullPath
		this.getYears();
		this.GetgeneralCheckoff();
		
		if(this.$route.params.loan_no){
			this.loan_no = this.$route.params.loan_no
			this.reportCode = thePath.split('/').slice(- 2).reverse().pop()
		}else{
			this.reportCode = thePath.substring(thePath.lastIndexOf('/') + 1)
		}
	    
	   if(this.reportCode == "FOSASTMNT"){
	   		this.isfosa = true
	   		this.showCalandar = true;
			this.showYear = false;
	   }
	  else if(this.reportCode == "DVDNTSTMNT"){
	   		this.isdevidend = true;
			this.showYear = true;
			this.showCalandar = false;
	   		
	   } 
	   else if(this.reportCode == "CHECKOFFSTMNT"){
			this.getcheckoffs=true;
			this.isdevidend = false;
			this.isdevidend = false;
			this.showYear = false;
			this.showCalandar = false;
	   }
	   else{
	   		this.loading = true
	   		this.fetchPdf();
		
	   }

		
	},	
}
</script>